import style from "./navBar.module.css";

function NavBar({
  visibleElements,
  elementsRef,
  handleLinkClick,
  isOpenMenu,
  toggleMenu,
}) {
  return (
    <nav className={style.navbar}>
      <button className={`${style["navbar__toggle"]}`} onClick={toggleMenu}>
        <i
          className={`${"bi bi-list"} ${style["navbar__hamburger"]}
        ${isOpenMenu ? style["navbar__hamburger--open"] : ""}`}
        />

        <i
          className={`${"bi bi-x-lg"} ${style["navbar__close"]}
        ${isOpenMenu ? style["navbar__close--open"] : ""}`}
        ></i>
      </button>

      <ul
        className={`${style["navbar__menu"]} ${
          isOpenMenu ? style["navbar__menu--open"] : ""
        }`}
      >
        <li className={style["navbar__item"]}>
          <a
            href="#about"
            className={`${style["navbar__link"]} 
          ${
            visibleElements.includes(elementsRef.current[2])
              ? style["navbar__link--active"]
              : ""
          }`}
            onClick={(e) => handleLinkClick(e, "about")}
          >
            Nosotros
          </a>
        </li>
        <li className={style["navbar__item"]}>
          <a
            href="#services"
            className={`${style["navbar__link"]} 
          ${
            visibleElements.includes(elementsRef.current[9])
              ? style["navbar__link--active"]
              : ""
          }`}
            onClick={(e) => handleLinkClick(e, "services")}
          >
            Servicios
          </a>
        </li>
        <li className={style["navbar__item"]}>
          <a
            href="#games"
            className={`${style["navbar__link"]} 
          ${
            visibleElements.includes(elementsRef.current[16])
              ? style["navbar__link--active"]
              : ""
          }`}
            onClick={(e) => handleLinkClick(e, "games")}
          >
            Juegos Indie
          </a>
        </li>
        <li className={style["navbar__item"]}>
          <a
            href="#contact"
            className={`${style["navbar__link"]} 
          ${
            visibleElements.includes(elementsRef.current[26])
              ? style["navbar__link--active"]
              : ""
          }`}
            onClick={(e) => handleLinkClick(e, "contact")}
          >
            Contacto
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
